import { MarketingContent as MarketingContentAPI } from '@occc-app/Activate/apiTypes';

import { MarketingContent } from './types';

type DeserializeMarketingContent = (marketingContentBody: MarketingContentAPI) => MarketingContent;
export const deserializeMarketingContent: DeserializeMarketingContent = (marketingContentBody) => ({
  disclaimer: marketingContentBody.attributes.disclaimer || '',
  disclaimerUrl: marketingContentBody.attributes.disclaimer_url || '',
  imageUrl: marketingContentBody.attributes.image_url || '',
  locale: marketingContentBody.attributes.locale || '',
  longDescription: marketingContentBody.attributes.long_description || '',
  shortDescription: marketingContentBody.attributes.short_description || '',
  terms: marketingContentBody.attributes.terms || '',
  termsUrl: marketingContentBody.attributes.terms_url || '',
  title: marketingContentBody.attributes.title || '',
});
